import { render } from "./AppMain.vue?vue&type=template&id=797b39be&scoped=true"
const script = {}

import "./AppMain.vue?vue&type=style&index=0&id=797b39be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-797b39be"]])

export default __exports__